import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import '../pages/css/ContactUs.css';
import { motion } from 'framer-motion';
import banner from '../images/contact-banner.jpg';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

// import emailjs from 'emailjs-com';

function ContactUs() {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        whatsapp: '',
        city: '',
        company: '',
        industry: '',
        softwareType: '',
        budget: '',
        timeline: '',
        extra: '',
        meetingDate: '',
        meetingHour: '08',   // new
        meetingMinute: '00', // new
        meetingAMPM: 'AM',   // new
        timezone: ''
    });

    const timezones = [
        "(GMT-12:00) International Date Line West",
        "(GMT-11:00) Midway Island, Samoa",
        "(GMT-10:00) Hawaii",
        "(GMT-09:00) Alaska",
        "(GMT-08:00) Pacific Time (US & Canada)",
        "(GMT-07:00) Mountain Time (US & Canada)",
        "(GMT-06:00) Central Time (US & Canada)",
        "(GMT-05:00) Eastern Time (US & Canada)",
        "(GMT-04:00) Atlantic Time (Canada)",
        "(GMT-03:30) Newfoundland",
        "(GMT-03:00) Greenland",
        "(GMT-02:00) Mid-Atlantic",
        "(GMT-01:00) Azores",
        "(GMT+00:00) London, Lisbon, Casablanca",
        "(GMT+01:00) Berlin, Rome, Paris",
        "(GMT+02:00) Cairo, Jerusalem",
        "(GMT+03:00) Moscow, Nairobi",
        "(GMT+03:30) Tehran",
        "(GMT+04:00) Abu Dhabi, Baku",
        "(GMT+04:30) Kabul",
        "(GMT+05:00) Islamabad, Karachi",
        "(GMT+05:30) India Standard Time",
        "(GMT+05:45) Kathmandu",
        "(GMT+06:00) Dhaka, Astana",
        "(GMT+06:30) Yangon (Rangoon)",
        "(GMT+07:00) Bangkok, Hanoi",
        "(GMT+08:00) Beijing, Perth, Singapore",
        "(GMT+09:00) Tokyo, Seoul",
        "(GMT+09:30) Adelaide, Darwin",
        "(GMT+10:00) Sydney, Guam",
        "(GMT+11:00) Magadan, Solomon Is.",
        "(GMT+12:00) Auckland, Fiji"
    ];



    const [loading, setLoading] = useState(false); // loader state
    const navigate = useNavigate(); // to redirect

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handlePhoneChange = (value) => {
        setFormData({ ...formData, phone: value });
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     setLoading(true);  // start loader

    //     const templateParams = {
    //         fullName: formData.fullName,
    //         email: formData.email,
    //         phone: formData.phone,
    //         whatsapp: formData.whatsapp,
    //         city: formData.city,
    //         company: formData.company,
    //         industry: formData.industry,
    //         softwareType: formData.softwareType,
    //         budget: formData.budget,
    //         timeline: formData.timeline,
    //         extra: formData.extra,
    //         meetingDate: formData.meetingDate,
    //         meetingTime: `${formData.meetingHour}:${formData.meetingMinute} ${formData.meetingAMPM}`,
    //         timezone: formData.timezone
    //     };

    //     const SERVICE_ID = 'service_tn8u41a';
    //     const TEMPLATE_ID = 'template_85rowrm';
    //     const USER_ID = 'iS38wRXHzZXycZSZM';

    //     // Send to your inbox
    //     emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID)
    //         .then(() => {
    //             // Send thank-you email to the user
    //             const thankYouParams = {
    //                 to_name: formData.fullName,
    //                 to_email: formData.email,
    //                 meeting_date: formData.meetingDate,
    //                 meeting_time: `${formData.meetingHour}:${formData.meetingMinute} ${formData.meetingAMPM}`,
    //                 meeting_timezone: formData.timezone,
    //             };

    //             // console.log(thankYouParams);

    //             const THANK_YOU_TEMPLATE_ID = 'template_7sl1ync'; // create a new thank-you template

    //             emailjs.send(SERVICE_ID, THANK_YOU_TEMPLATE_ID, thankYouParams, USER_ID)
    //                 .then(() => {
    //                     setLoading(false);  // stop loader
    //                     setFormData({
    //                         fullName: '',
    //                         email: '',
    //                         phone: '',
    //                         whatsapp: '',
    //                         city: '',
    //                         company: '',
    //                         industry: '',
    //                         softwareType: '',
    //                         budget: '',
    //                         timeline: '',
    //                         extra: '',
    //                         meetingDate: '',
    //                         meetingHour: '08',
    //                         meetingMinute: '00',
    //                         meetingAMPM: 'AM',
    //                         timezone: ''
    //                     });
    //                     navigate('/thankyou');  // redirect to thankyou page
    //                 })
    //                 .catch((err) => {
    //                     console.error('Failed to send thank-you email:', err);
    //                     alert('Form submitted, but thank-you email failed.');
    //                     navigate('/thankyou');
    //                 });
    //         })
    //         .catch((err) => {
    //             console.error('Failed to send lead email:', err);
    //             alert('Failed to send email. Please try again.');
    //         });
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            fullName: formData.fullName,
            email: formData.email,
            phone: formData.phone,
            whatsapp: formData.whatsapp,
            city: formData.city,
            company: formData.company,
            industry: formData.industry,
            softwareType: formData.softwareType,
            budget: formData.budget,
            timeline: formData.timeline,
            extra: formData.extra,
            meetingDate: formData.meetingDate,
            meetingTime: `${formData.meetingHour}:${formData.meetingMinute} ${formData.meetingAMPM}`,
            timezone: formData.timezone
        };

        try {
            const response = await fetch("https://peregrinee.com/hriasMailServer/contact-us-mail.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.status === "success") {
                setLoading(false);
                setFormData({
                    fullName: '',
                    email: '',
                    phone: '',
                    whatsapp: '',
                    city: '',
                    company: '',
                    industry: '',
                    softwareType: '',
                    budget: '',
                    timeline: '',
                    extra: '',
                    meetingDate: '',
                    meetingHour: '08',
                    meetingMinute: '00',
                    meetingAMPM: 'AM',
                    timezone: ''
                });

                navigate('/thankyou');
            } else {
                alert("Failed to send. Please try again.");
                setLoading(false);
            }

        } catch (error) {
            console.error("Error:", error);
            alert("Server error. Please try again later.");
            setLoading(false);
        }
    };


    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);


    return (
        <>
            <section
                id="contact-section-page"
                style={{
                    backgroundImage: `url(${banner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative', // Important for overlay
                    zIndex: 1,
                }}
            >
                {/* Overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.4)', // semi-transparent black
                        zIndex: 2,
                    }}
                ></div>

                <section className="container-fluid px-3 px-md-5 pt-3 pb-5" style={{ position: 'relative', zIndex: 3 }}>
                    <div className="row justify-content-center text-center">
                        <div className="col-lg-10">
                            <h1 className="fw-bold display-5 text-white" style={{ fontSize: '4.5rem' }}>Contact
                                Us
                            </h1>
                            <p className="fs-2 fw-medium text-white mt-3">
                                You deserve top 1% Software development Service Provider
                            </p>
                        </div>
                    </div>
                </section>


            </section>
            <div className="container my-5">

                {/* <div
                    className="calendly-inline-widget"
                    data-url="https://calendly.com/contact-peregrinee/consultation-call"
                    style={{ minWidth: "320px", height: "700px" }}
                ></div> */}


                <div className="lead-form-container p-4 rounded position-relative">
                    <h1 className="custom-heading fw-bold mt-2">
                        Get in <span>Touch</span>!
                    </h1>
                    <p className="position-absolute top-0 end-0 mt-2 me-3" style={{ fontSize: '0.85rem', color: '#ec4899', fontWeight: 'bold' }}>
                        * marked are mandatory fields
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="fullName"
                                    placeholder="Full Name *"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                    required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    placeholder="Email *"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <PhoneInput
                                    country={'in'}
                                    inputClass="w-100"
                                    value={formData.phone}
                                    onChange={handlePhoneChange}
                                    inputStyle={{ height: '38px' }}
                                    required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="whatsapp"
                                    placeholder="WhatsApp Number"
                                    value={formData.whatsapp}
                                    onChange={handleChange} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label" style={{ fontSize: '0.85rem', color: '#ec4899', fontWeight: 'bold' }}>Meeting Date *</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="meetingDate"
                                    value={formData.meetingDate}
                                    onChange={handleChange}
                                    required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label" style={{ fontSize: '0.85rem', color: '#ec4899', fontWeight: 'bold' }}>Meeting Time *</label>
                                <div className="d-flex">
                                    <select
                                        className="form-control me-2"
                                        name="meetingHour"
                                        value={formData.meetingHour}
                                        onChange={handleChange}
                                        required
                                    >
                                        {[...Array(12)].map((_, i) => {
                                            const hour = (i + 1).toString().padStart(2, '0');
                                            return <option key={hour} value={hour}>{hour}</option>;
                                        })}
                                    </select>

                                    <select
                                        className="form-control me-2"
                                        name="meetingMinute"
                                        value={formData.meetingMinute}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="00">00</option>
                                        <option value="30">30</option>
                                    </select>

                                    <select
                                        className="form-control"
                                        name="meetingAMPM"
                                        value={formData.meetingAMPM}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="AM">AM</option>
                                        <option value="PM">PM</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <select
                                    className="form-control"
                                    name="timezone"
                                    value={formData.timezone}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Timezone *</option>
                                    {timezones.map((zone, index) => (
                                        <option key={index} value={zone}>{zone}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-6 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="city"
                                    placeholder="Your City *"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required />
                            </div>
                            <div className="col-12 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="company"
                                    placeholder="Company Name *"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required />
                            </div>
                            <div className="col-12 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="industry"
                                    placeholder="Please Specify Your Industry *"
                                    value={formData.industry}
                                    onChange={handleChange}
                                    required />
                            </div>
                            <div className="col-12 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="softwareType"
                                    placeholder="What type of software do you want? *"
                                    value={formData.softwareType}
                                    onChange={handleChange}
                                    required />
                            </div>
                            <div className="col-12 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="budget"
                                    placeholder="What's your budget for the project?"
                                    value={formData.budget}
                                    onChange={handleChange} />
                            </div>
                            <div className="col-12 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="timeline"
                                    placeholder="Any timeline preference ?"
                                    value={formData.timeline}
                                    onChange={handleChange} />
                            </div>
                            <div className="col-12 mb-4">
                                <textarea
                                    className="form-control"
                                    name="extra"
                                    rows="4"
                                    placeholder="Please share anything that'll help prepare for our meeting *"
                                    value={formData.extra}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>
                            <div className="col-12 text-center">
                                <button type="submit" className="btn submit-btn px-5 py-2 fw-bold" disabled={loading}>
                                    {loading ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div></>
    );
}

export default ContactUs;
